import {crc32} from "../../../../../base/js/helpers/crc32";
import {
  $_body,
  $_window
}              from "../../../../../base/js/helpers/dom";

const DATA_TAG = 'tag';
const DATA_TAG_ID = 'tag-id';

export default (/** ContentBrowserModel */parentModel) => {
  const $context = parentModel.context;
  const $component = $context.find('.content_browser__filters');

  const $filterOptions = $component.find('.filter_option');

  const $categories = $component.find('.filter_option--category');

  init();

  function init() {
    selectCategory(parentModel.filter.category, false);

    initFilterOptions();
    initMobile();
    showHideAll();
  }

  function initMobile() {
    const $showFiltersButton = $component.find('.show-filter-button');
    const $closeFiltersButton = $component.find('.close-filter-button');
    const $filterSubs = $component.find('.filter_group_wrapper--sub');
    const $clearAllButton = $component.find('.clear-all-button');

    $showFiltersButton.on('click', function () {
      $filterSubs.addClass('show-filters');
      $_body().addClass("fixed");
    });
    $closeFiltersButton.on('click', function () {
      $filterSubs.removeClass('show-filters');
      $_body().removeClass("fixed");
    });
    $clearAllButton.on('click', function () {
      $component.find('.filter_group--sub.active').each((index, group) => {
        const $group = $(group);

        $group.find(`.filter_option input`)
          .each((index, input) => {
            input.checked = true;
          });
      });

      updateFilter();

      $(this).hide();
    });
  }

  function showHideAll() {
    const $showFiltersButton = $('.filter_group__show_all a');

    $showFiltersButton.on('click', function () {
      const $parent = $(this).parent().parent();

      $parent.toggleClass('options--hide_empty');

    });
  }

  function initFilterOptions() {
    $filterOptions.on('click', function () {
      const $this = $(this);
      const $input = $this.find('input');
      const isChecked = Boolean($input.prop('checked'));
      const isAll = $this.data('all');
      const type = $input.attr('type');
      const newValue = !isChecked;
      const isCategory = type === 'radio';

      $input.prop('checked', isCategory || newValue);

      //region Category

      if (isCategory)
      {
        if (newValue)
        {
          selectCategory($this.attr('data-tag'));
        }

        return;
      }

      //endregion

      //region Sub-tags

      const $parent = $this.closest('.filter_group__options');

      if (isAll)
      {
        $parent.find('input').prop('checked', newValue);

        updateFilter();

        return;
      }

      if (!isAll && !newValue)
      {
        $parent.find(`.filter_option[data-all='1'] input`).prop('checked', false);
      }

      updateFilter();

      //endregion
    });
  }

  function selectCategory(categoryTag, doNotify = true) {
    categoryTag = categoryTag || $categories.first().attr('data-tag');
    parentModel.filter.category = categoryTag;

    $categories.each((index, category) => {
      const $category = $(category);
      const $input = $category.find('input');
      const tag = $category.attr('data-tag');
      $input.prop('checked', categoryTag === tag);
    });

    $component.find('.filter_group--sub').removeClass('active');
    $component.find(`.filter_group--sub[data-parent='${categoryTag}']`).addClass('active');

    let allChecked = true;
    const categoryHash = crc32(categoryTag).toString(16);
    const selectedTags = parentModel.filter.selectedTags[categoryHash];
    if (selectedTags)
    {
      $component.find('.filter_group--sub.active')
        .each((index, group) => {
          const $group = $(group);
          const tagGroup = $group.attr('data-group');
          const tagGroupHash = crc32(tagGroup).toString(16);
          const groupSelectedTags = selectedTags[tagGroupHash];

          if (groupSelectedTags)
          {
            $group.find(`.filter_option[data-all!=1] input`)
              .each((index, input) => {
                const $input = $(input);
                const tagId = Number($input.data(DATA_TAG_ID));
                input.checked = groupSelectedTags.indexOf(tagId) > -1;
                if (!input.checked)
                {
                  allChecked = false;
                }
              });
          }
          else
          {
            $group.find(`.filter_option input`)
              .each((index, input) => {
                input.checked = true;
              });
          }
        });
    }
    else
    {
      $component.find('.filter_group--sub.active .filter_option input')
        .each((index, input) => {
          input.checked = true;
        });
    }

    setTimeout(() => {
      $component.find('.filter_group__btn--clear')
        .off('click')
        .on('click', function () {
          const $this = $(this);
          const $parent = $this.closest('.filter_group--sub');
          $parent.find('input').prop('checked', false);

          updateFilter();
        });
    });

    updateFilter(doNotify);
  }

  function updateFilter(doNotify = true) {
    /** @type {FilterModel} */
    const filter = parentModel.filter = {
      category:     parentModel.filter.category,
      selectedTags: parentModel.filter.selectedTags,
    };

    const category = parentModel.filter.category;
    const categoryHash = crc32(category).toString(16);
    const selectedTags = filter.selectedTags[categoryHash] = {};

    let allChecked = true;

    $component.find('.filter_group--sub.active')
      .each((index, group) => {
        let groupAllChecked = true;
        let groupNoneChecked = true;
        const $group = $(group);
        const tagGroup = $group.attr('data-group');
        const tagGroupHash = crc32(tagGroup).toString(16);
        const groupSelectedTags = selectedTags[tagGroupHash] = [];

        /** @type {TagModel[]} */
        const tags = [];
        $group.find(`.filter_option[data-all!=1] input`)
          .each((index, input) => {
            if (input.checked)
            {
              const $input = $(input);
              const tagId = Number($input.data(DATA_TAG_ID));
              tags.push({
                id:   tagId,
                name: $input.data(DATA_TAG),
              });
              groupSelectedTags.push(tagId);
              groupNoneChecked = false;
            }
            else
            {
              allChecked = groupAllChecked = false;
            }
          });

        if (groupAllChecked)
        {
          selectedTags[tagGroupHash] = [];
          delete selectedTags[tagGroupHash];
        }
        else
        {
          if (groupNoneChecked)
          {
            selectedTags[tagGroupHash] = [0];
          }
          $group.find(`.filter_option[data-all=1] input`)
            .each((index, input) => {
              input.checked = false;
            });
        }

        filter[tagGroup] = tags;
      });

    const $clearAllButton = $component.find('.clear-all-button');
    const $window = $_window();
    const width = $window.width();

    if (width < 768)
    {
      if (allChecked)
      {
        $clearAllButton.hide();
      }
      else
      {
        $clearAllButton.show();
      }
    }

    /*allChecked = true;
    const selectedTags = filter.selectedTags = [];
    $component.find('.filter_group--sub .filter_option[data-all!=1] input')
      .each((index, /!** HTMLInputElement *!/input) => {
        if (input.checked)
        {
          const $input = $(input);
          const tagId = Number($input.data(DATA_TAG_ID));
          selectedTags.push(tagId);
        }
        else
        {
          allChecked = false;
        }
      });*/

    if (allChecked)
    {
      filter.selectedTags[categoryHash] = null;
      delete filter.selectedTags[categoryHash];
    }

    if (doNotify)
    {
      parentModel.onFilterUpdate();
    }
  }
}
